import { Address } from "../store/models/Address";
import { NA } from "../store/constants";

export const getFullName = (firstName: string, middleName: string, lastName: string, suffix?: string) => {
  const name = `${firstName} ${middleName} ${lastName}${suffix?.trim() ? ` ${suffix}` : ""}`;
  return name.trim() ? name : NA;
};

export const getFullAddress = ({ address1, address2, city, state, county, zip }: Address) => {
  const address = `${address1} ${address2} ${city} ${state} ${county} ${zip}`;
  return address.trim() ? address : NA;
};

export const getAddressLines = (address: Address) => {
  const addressLines = `${address.address1} ${address.address2}`;
  return addressLines.trim() ? addressLines : NA;
}

export const getCityStateZip = (address: Address) => {
  const cityStateZipLine = `${address.city}, ${address.state} ${address.zip}`;
  return cityStateZipLine.trim() ? cityStateZipLine : NA;
}

export const formatSSN = (ssn: string) => {
  return ssn.length === 9
    ? ssn.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3")
    : ssn;
};

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalizeWords = (str: string) => {
  return str
    .split(" ")
    .map(word => capitalizeFirstLetter(word))
    .join(" ");
};

export const removeTrailingPeriods = (str: string) => {
  return str.replace(/\.+$/, "");
};

// Format amount with dollar sign and commas but no decimal places
export const formatToDollarAmount = (amount: string) => {
  if (!amount) return NA;
  const parsedAmount = parseFloat(amount);
  if (isNaN(parsedAmount)) return NA;
  return `$${parsedAmount.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
};